import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const attendanceData = this.props.attendanceData;
    const searchData = this.props.searchData;
    const attendanceDetail = this.props.attendanceDetail;
    const handleDateTime = this.props.handleDateTime;
    const regularHours = this.props.regularHours;
    const formatTotalHours = this.props.formatDecimalHours;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <div>
          <h3><center><u>Employee Attendance Details Report</u></center></h3>
          <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
          <h4><center>{attendanceDetail.registrationNumber === '' ? 'All Employees' : 'Reg No: ' + attendanceDetail.registrationNumber}</center></h4>
          <h4><center>{attendanceDetail.date}</center></h4>
          <h4><center>{attendanceDetail.employeeTypeID == 0 ? 'Employee Type: All' : 'Employee Type: ' + searchData.employeeTypeName}</center></h4>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050} style={{paddingLeft:"10px", paddingRight:"10px"}}>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow style={{ border: '1px solid black' }}>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Reg No</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Employee Code</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Employee Name</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Employee Type</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>In Time</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Out Time</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>OT Hours</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Regular Hours</TableCell>
                      <TableCell align={'center'} style={{border: "2px solid black", fontWeight: "bold"}}>Total Hours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {attendanceData.map((data, index) => (
                      <TableRow key={index} style={{ border: '1px solid black' }}>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{data.registrationNumber}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{data.employeeCode}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{data.employeeName}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 130, fontWeight: 'bold' }} align="left">{data.employeeTypeName}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }}align="center">{data.inTime  ? handleDateTime(data.inTime) : "N/A"}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="center">{data.outTime ? handleDateTime(data.outTime) : <b style={{color: "red"}}>Pending...</b>}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="right">{data.otHours}m</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="right">{regularHours(data.inTime, data.outTime, data.otHours)}</TableCell>
                        <TableCell style={{ border: "1px solid black", padding: "6px", width: 110 }} align="center">{formatTotalHours(data.totalHours)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </div>
          <div>&nbsp;</div>
          <h4><center>*******End of List*******</center></h4>
        </div>
      </div>
    );
  }
}